import "./confirmationModal.css";
import { Button, Group, Modal, Stack, Text, Title } from "@mantine/core";

interface ConfirmationModalProps {
  opened: boolean;
  text: string;
  title: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm?: () => void;
  onCancel: () => void;
}

const ConfirmationModal = ({
  opened,
  text,
  title,
  confirmText,
  cancelText,
  onConfirm,
  onCancel,
}: ConfirmationModalProps) => {
  return (
    <Modal
      title={<Title order={4}>{title}</Title>}
      opened={opened}
      onClose={onCancel}
      centered
    >
      <Stack gap="xl" w="100%">
        <Text>{text}</Text>
        {cancelText ? (
          <Group justify="flex-end">
            <Button onClick={onCancel}>{cancelText}</Button>
            <Button bg="red" onClick={onConfirm}>
              {confirmText}
            </Button>
          </Group>
        ) : onConfirm != null ? (
          <Group justify="flex-end">
            <Button onClick={onConfirm}>{confirmText}</Button>
          </Group>
        ) : null}
      </Stack>
    </Modal>
  );
};

export default ConfirmationModal;
